import React from 'react';
import {
  TRAIN_DERAILMENT,
  TEST_TRAIN_DERAILMENT,
} from '@rsos/constants/alertTypes';
import TrainCustomContent from './componentsByIncidentType/trainCustomComponents/AccordionContent/AccordionContent';
import TrainCustomHeader from './componentsByIncidentType/trainCustomComponents/AccordionHeader/AccordionHeader';
import AccordionSectionTitle from './componentsByIncidentType/trainCustomComponents/AccordionSectionTitle';

export const fetchAccordionTitle = (incidentType, title) => {
  switch (incidentType) {
    case TRAIN_DERAILMENT: {
      return <AccordionSectionTitle title={title} />;
    }
    case TEST_TRAIN_DERAILMENT: {
      return <AccordionSectionTitle title={title} />;
    }
    default:
      return '';
  }
};

export const fetchAccordionHeader = (incidentType, data) => {
  switch (incidentType) {
    case TRAIN_DERAILMENT: {
      return <TrainCustomHeader data={data} />;
    }
    case TEST_TRAIN_DERAILMENT: {
      return <TrainCustomHeader data={data} />;
    }
    default:
      return '';
  }
};

export const fetchAccordionContent = (incidentType, props) => {
  switch (incidentType) {
    case TRAIN_DERAILMENT: {
      return <TrainCustomContent props={props} />;
    }
    case TEST_TRAIN_DERAILMENT: {
      return <TrainCustomContent props={props} />;
    }
    default:
      return <></>;
  }
};

export const fetchCustomAccordionStyle = incidentType => {
  switch (incidentType) {
    case TRAIN_DERAILMENT:
      return {
        borderRadius: '5px',
        overflow: 'hidden',
      };
    case TEST_TRAIN_DERAILMENT:
      return {
        borderRadius: '5px',
        overflow: 'hidden',
      };
    default:
      return null;
  }
};
